import { ILanguage } from "../services/action/types";

interface Args {
  text: ILanguage,
  language?: string;
}

const selectLanguage = ({ text, language }: Args) => {
  let goodLanguage = "fr";

  if (language) {
    goodLanguage = language;
    if (language.includes("fr-")) {
      goodLanguage = "fr";
    }
  }

  if (!text) {
    return "";
  }

  if (!!text[goodLanguage]) {
    return text[goodLanguage];
  }
  // fallback language
  else if (!!text["fr"]) {
    return text["fr"];
  }
  // the only language
  else if (!!Object.values(text)?.[0]) {
    return Object.values(text)[0];
  }
  return "";
};

export default selectLanguage;
